// extracted by mini-css-extract-plugin
export var productImage = "_rw-1";
export var viewLink = "_rw-2";
export var wishlistItem = "_rw-0";